import { render } from "./Checkout.vue?vue&type=template&id=242fc85a&bindings={\"schemaValidation\":\"data\",\"sending\":\"data\",\"status\":\"data\",\"stripe_data\":\"data\",\"form_schema\":\"data\",\"stripeTokenHandler\":\"options\",\"onSubmit\":\"options\",\"createPaymentIntent\":\"options\",\"confirmCardPayment\":\"options\",\"createOrder\":\"options\"}"
import script from "./Checkout.vue?vue&type=script&lang=js"
export * from "./Checkout.vue?vue&type=script&lang=js"

import "./Checkout.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script